import { useCallback } from 'react';
import { rage } from '~/rage';
import {
	IModalReplyDefault,
	ModalButtonColor,
	ModalType,
	WalletType,
} from '~/shared';
import { useLayoutSelector } from '../redux';

const useBuy = () => {
	const activeList = useLayoutSelector((state) => state.tuningShop.activeList);
	const activeListIndex = useLayoutSelector(
		(state) => state.tuningShop.activeListIndex,
	);

	const handleBuy = useCallback(
		(walletType: WalletType) => {
			if (activeListIndex === null) {
				return;
			}

			const item = activeList[activeListIndex];
			const actualPrice = rage.techTuning.getItemBuyPrice(item.id);

			const text = `Вы действительно хотите оплатить ${
				walletType === WalletType.Cash
					? 'наличными'
					: walletType === WalletType.Bank
					? 'картой'
					: 'донат-валютой'
			} товар "${item.name}"`;

			rage.modal.showModal(
				{
					type: ModalType.Price,
					title: 'Подтверждение',
					text: text,
					price: actualPrice,
					// wallet:
					// 	item.currency === Currency.Ruble
					// 		? WalletType.Cash
					// 		: WalletType.Donate,
					wallet: WalletType.Cash,
					acceptButton: { text: 'Оплатить', color: ModalButtonColor.Success },
					cancelButton: {
						text: 'Отменить',
						color: ModalButtonColor.Secondary,
					},
				},
				(result: IModalReplyDefault) => {
					if (result.isAccepted) {
						rage.techTuning.buyItem(item.id, walletType);
					}
				},
			);
		},
		[activeListIndex, activeList],
	);

	return { handleBuy };
};

export { useBuy };
